<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form inline class="inline-form">
          <el-form-item label="结算时间">
            <date-range-picker v-model="settleTime" :value="settleTime" @getChange="dateChange"></date-range-picker>
          </el-form-item>
          <el-form-item label="交易单号">
            <el-input
              class="search-input"
              v-model="orderId"
              placeholder="交易单号"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-select
              class="search-input"
              v-model="merchantId"
              placeholder="模糊搜索"
              clearable
              filterable
              :filter-method="handleMerchantInfoFilter">
              <el-option
                v-for="(item, index) in subMerchantNamesList"
                :key="index"
                :label="item.code"
                :value="item.code">
                <span class="value">{{ item.code }}</span>
                <span class="name">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <payment-type
            :payType="searchInfo.payType"
            :payChannel="searchInfo.paymentType"
            @getPayType="getPayType"
            @getPayChannel="getPaymentType"></payment-type>
          <el-form-item label="交易状态">
            <el-select style="width: 150px;" v-model="operatorType" clearable>
              <div v-if="searchInfo.payType === 0">
                <el-popover
                  placement="right"
                  title=""
                  width="200"
                  trigger="hover"
                  content="退款包括退款中和退款成功两种状态，可通过“交易数据查询”查询">
                  <el-option slot="reference" label="退款" value="1"></el-option>
                </el-popover>
                <el-option label="支付成功" value="2"></el-option>
                <el-option label="退款失败" value="3"></el-option>
              </div>
              <div v-else>
                <el-option label="交易成功" value="0"></el-option>
                <el-popover
                  placement="right"
                  title=""
                  width="200"
                  trigger="hover"
                  content="退款包括退款中和退款成功两种状态，可通过“交易数据查询”查询">
                  <el-option slot="reference" label="退款" value="1"></el-option>
                </el-popover>
                <el-option label="退款失败" value="2"></el-option>
                <el-option label="撤销成功" value="3"></el-option>
                <el-option label="撤销失败" value="4"></el-option>
                <el-option label="冲正成功" value="5"></el-option>
                <el-option label="预授权完成" value="6"></el-option>
                <el-option label="预授权完成冲正" value="7"></el-option>
                <el-option label="预授权完成通知" value="8"></el-option>
                <el-option label="预授权完成撤销" value="9"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="订单金额(元111)">
            <el-input
              style="width:100px;"
              v-model="minAmount"
              auto-complete="off"
              placeholder="正整数"></el-input> -
            <el-input
              style="width:100px;"
              v-model="maxAmount"
              auto-complete="off"
              placeholder="正整数"></el-input>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
            <auth-button
              opt="export"
              :plain="true"
              icon="el-icon-download"
              :loading="exportButtonLoading"
              @click.native="exportClick"
              label="导出"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 汇总 -->
      <el-col>
        <div class="sum-view">
          <div>
            <div class="sum-item-title">应结订单金额</div>
            <div>{{ totalInfo.totalAmountStr || '--' }}</div>
          </div>
          <div>
            <div class="sum-item-title">手续费总额</div>
            <div>{{ totalInfo.totalCommissionAmountStr || '--' }}</div>
          </div>
          <div>
            <div class="sum-item-title">结算金额</div>
            <div>{{ totalInfo.totalSettleAmountStr || '--' }}</div>
          </div>
        </div>
      </el-col>
    </el-card>
    <!-- table -->
    <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%;"
        v-loading="tableLoading"
        :data="orderBillingDetailsList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="tranTime"
          label="结算时间"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="orderId"
          label="交易单号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="merchantId"
          label="商户编号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商户简称"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="paymentTypeStr"
          label="交易类型"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="tradeStatusStr"
          label="交易状态"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="preAmount"
          label="应结订单金额"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <div>{{ Number(scope.row.preAmount / 100).toFixed(2) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="rate"
          label="商户费率"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <div>{{ Number(scope.row.rate / 100).toFixed(2) }}%</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="singleFixFeeStr"
          label="单笔提现手续费"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="sumFee"
          label="手续费总额"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <div>{{ Number(scope.row.sumFee / 100).toFixed(2) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="maxable"
          label="手续费是否封顶"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <div>{{ scope.row.maxable | formatMaxable }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="结算金额"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <div>{{ Number(scope.row.amount / 100).toFixed(2) }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
  </div>
</template>

<script>
import qs from 'qs'
import { parseTime } from '@/utils/formatTime'
import paymentType from '@/components/paymentType/paymentType'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { getAllSubMerchantNames, queryOrderBillingDetailsList, exportOrderBillingDetails } from '@/api/settle.js'
export default {
  name: 'OrderBillingDetails',
  components: {
    paymentType,
    dateRangePicker,
    pagination
  },
  data () {
    const todayStr = (parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')).substr(0, 10) + ' 23:59:59'
    const toadyZero = new Date(new Date().getTime() - 3600 * 1000 * 24)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}').substr(0, 10) + ' 00:00:00'
    return {
      loading: false,
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 20
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        merchantId: '',
        orderId: '',
        paymentType: '1, 2, 5',
        operatorType: '',
        minAmount: '',
        maxAmount: '',
        payType: 0
      },
      settleTime: [todayZeroStr, todayStr],
      subAgentId: '',
      merchantId: '',
      orderId: '',
      paymentType: '',
      maxAmount: '',
      minAmount: '',
      operatorType: '',
      tableLoading: false,
      exportButtonLoading: false,
      subMerchantNamesList: [],
      subMerchantNamesList_back: [],
      orderBillingDetailsList: [],
      totalInfo: {}
    }
  },
  mounted () {
    this.getDefaultData()
  },
  beforeDestroy () {},
  methods: {
    /**
     * @description 初始加载数据方法
     */
    async getDefaultData () {
      // this.loading = true
      await this.getAllSubMerchantNames()
      await this.searchClick()
      this.loading = false
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    validAmount () {
      var num = /^[0-9]+$/
      if (this.minAmount !== '' && (!num.test(this.minAmount))) {
        this.minAmount = ''
        this.$message({
          showClose: true,
          message: '应结订单金额必须为正整数',
          type: 'warning'
        })
        return false
      }
      if (this.maxAmount !== '' && (!num.test(this.maxAmount))) {
        this.maxAmount = ''
        this.$message({
          showClose: true,
          message: '应结订单金额必须为正整数',
          type: 'warning'
        })
        return false
      }
      if (this.minAmount !== '' && this.maxAmount !== '') {
        if (parseInt(this.minAmount) > parseInt(this.maxAmount)) {
          this.maxAmount = ''
          this.$message({
            showClose: true,
            message: '最大应结订单金额不能小于最小金额',
            type: 'warning'
          })
          return false
        }
      }
      return true
    },
    /**
     * 交易类型选择change
     */
    payTypeSelectChange (value) {
      if (value === 0) {
        this.payChannel = [1, 2, 5]
      }
      if (value === 1) {
        this.payChannel = [0]
      }
    },
    /**
     * @description 筛选查询按钮点击
     */
    searchClick (noReset) {
      if (!this.merchantId) {
        this.$message({
          message: '请先输入商户编号',
          type: 'warning'
        })
        return
      }
      console.log('查询点击')
      var amountflag = this.validAmount()
      if (!amountflag) {
        return
      }
      this.setSearchInfoParams(noReset)
      this.queryOrderBillingDetailsList()
    },
    /**
     * 导出按钮点击
     */
    exportClick () {
      console.log('导出点击')
      var amountflag = this.validAmount()
      if (!amountflag) {
        return
      }
      this.setSearchInfoParams(true)
      const startDate = new Date(this.searchInfo.startTime)
      const endDate = new Date(this.searchInfo.endTime)
      if (!this.searchInfo.startTime || !this.searchInfo.endTime || (startDate.getMonth() !== endDate.getMonth() && endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 31)) {
        this.$message({
          message: '请筛选1个月内的数据进行导出',
          type: 'error'
        })
        return
      }
      this.exportOrderBillingDetails()
    },
    /**
     * 组装筛选参数
     */
    setSearchInfoParams (noReset) {
      this.searchInfo.minAmount = this.minAmount || ''
      this.searchInfo.maxAmount = this.maxAmount || ''
      this.searchInfo.startTime = this.settleTime && this.settleTime[0] ? this.settleTime[0] : ''
      this.searchInfo.endTime = this.settleTime && this.settleTime[1] ? this.settleTime[1] : ''
      this.searchInfo.merchantId = this.merchantId.replace(/ /g, '') || ''
      this.searchInfo.orderId = this.orderId.replace(/ /g, '') || ''
      this.searchInfo.operatorType = this.operatorType || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      Object.assign(this.searchInfo, this.paginations)
    },
    dateChange (value) {
      this.settleTime = value
    },
    /**
     * @description 删除提交参数中的空字段
     * @param {Object} params 搜索内容对象
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * 商户选择筛选商户方法
     */
    handleMerchantInfoFilter (queryString) {
      if (queryString) {
        this.subMerchantNamesList = this.subMerchantNamesList_back.filter(item => {
          return item.code.toLowerCase().includes(queryString.toLowerCase()) || item.name.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.subMerchantNamesList = this.subMerchantNamesList_back
      }
    },
    /**
     * 获取商户编号下拉列表
     */
    getAllSubMerchantNames () {
      return new Promise((resolve, reject) => {
        getAllSubMerchantNames('').then(response => {
          console.log('getAllSubMerchantNames response:', response)
          if (response.error_code === '0') {
            this.subMerchantNamesList = response.data
            this.subMerchantNamesList_back = [...this.subMerchantNamesList]
            this.merchantId = this.subMerchantNamesList[0].code
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    /**
     * 订单计费明细查询
     */
    queryOrderBillingDetailsList () {
      this.loading = true
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      queryOrderBillingDetailsList(params).then(response => {
        console.log('queryOrderBillingDetailsList response:', response)
        this.loading = false
        if (response.error_code === '0') {
          this.orderBillingDetailsList = response.data.list
          this.paginations.count = response.data.totalCount
          this.totalInfo = {
            totalAmountStr: response.data.totalAmountStr,
            totalCommissionAmountStr: response.data.totalCommissionAmountStr,
            totalSettleAmountStr: response.data.totalSettleAmountStr
          }
          if (parseInt(this.paginations.count) > 10000) {
            this.$message({
              message: '最多筛选出10000条数据，请重新筛选',
              type: 'warning'
            })
          }
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 订单计费明细查询导出
     */
    exportOrderBillingDetails () {
      this.exportButtonLoading = true
      const params = qs.stringify(Object.assign({}, this.searchInfo, {
        moduleCode: 2,
        moduleName: '结算',
        menuName: '订单计费明细'
      }))
      console.log(params)
      exportOrderBillingDetails(params).then(response => {
        this.exportButtonLoading = false
        if (response.error_code === '0') {
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    formatDate (item) {
      return parseTime(new Date(item.fTime), '{y}-{m}-{d} {h}:{i}:{s}')
    },
    // 获取组件中交易类型及交易渠道选中值
    getPayType (val) {
      if (val !== this.searchInfo.payType) this.operatorType = ''
      this.searchInfo.payType = val
    },
    getPaymentType (val) {
      this.searchInfo.paymentType = val
    }
  },
  computed: {},
  filters: {
    formatMaxable (value) {
      switch (value) {
        case 0:
          return '不封顶'
        case 1:
          return '封顶'
        default:
          return '未知'
      }
    }
  }
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.sum-view {
  margin: 10px;
  text-align: center;
  font-size: 14px;
  display: flex;
  justify-items: center;
  justify-content: space-around;
}
.sum-item-title {
  font-weight: 700;
  margin-bottom: 30px;
}
</style>
